














import { createComponent, watch, ref, computed } from "@vue/composition-api";
import {
  useStringValidation,
  formatValidationResponse
} from "@web-components/compositions/useStringValidation";
import { useAutoFillFix } from "@web-components/compositions/useAutoFillFix";

interface BaseStringInputProps {
  value?: string;
  type?: string;
  regex?: RegExp;
  required: boolean;
  isEmail: boolean;
  minLength: number;
}

export default createComponent({
  inheritAttrs: false,
  props: {
    value: {
      required: false,
      type: String
    },
    type: {
      required: false,
      type: String
    },
    regex: {
      required: false,
      type: RegExp
    },
    required: {
      type: Boolean,
      default: false
    },
    minLength: {
      type: Number,
      default: 0
    },
    isEmail: {
      type: Boolean,
      default: false
    }
  },
  setup(props: Readonly<BaseStringInputProps>, context) {
    let inputValue = ref(props.value || "");

    const validationResponse = useStringValidation({
      inputRef: inputValue,
      required: props.required,
      minLength: props.minLength,
      regex: props.regex
    });

    watch([inputValue, validationResponse.valid], ([_, a]: any) => {
      context.emit("validation", formatValidationResponse(validationResponse));
    });

    const onKeyUp = (value: string) => {
      inputValue.value = value;
      validationResponse.setDirty(true);
      context.emit("input", value);
    };

    const { inputRef } = useAutoFillFix(inputValue, onKeyUp);

    const isError = computed(() => {
      return (
        validationResponse.regexError.value ||
        validationResponse.minLengthError.value ||
        validationResponse.requiredError.value
      );
    });

    return {
      onKeyUp,
      isError,
      inputRef
    };
  }
});
